<template>
  <div class="bg-mentalnc text-gray-700">
    <layouts-auth-width>
      <div class="p-2 h-14 grid grid-cols-12 content-center">
        <div class="col-span-5 flex items-center justify-start">
          <transition name="fade" mode="out-in">
            <div v-if="!store.state.menu.sidebar.open">
              <base-icon-text @click="store.dispatch('menu/switchSidebarOpen')" class="cursor-pointer" :path="mdiMenu" text="メニュー" />
            </div>
            <div v-else>
              <base-icon-text @click="store.dispatch('menu/switchSidebarOpen')" class="cursor-pointer" :path="mdiClose" :text="t('word.close')" />
            </div>
          </transition>
        </div>
        <div class="col-span-2 flex items-center justify-center">
          <router-link :to="homePath">
            <img class="transition-bounce w-12" src="@/assets/images/header_logo.png" alt="LOGO">
          </router-link>
        </div>
        <div class="col-span-5 flex items-center justify-end">
          <div class="mr-4">
            <router-link to="/account">
              <base-icon-text class="transition-bounce" :path="mdiAccount" text="マイページ" />
            </router-link>
          </div>
          <div class="mr-4">
            <router-link to="/course">
              <base-icon-text class="transition-bounce" :path="mdiBookOpenPageVariant" :text="t('course.title')" />
            </router-link>
          </div>
          <div class="mr-4">
            <router-link to="/seminar">
              <base-icon-text class="transition-bounce" :path="mdiCalendarCheck" text="セミナー" />
            </router-link>
          </div>
          <div v-if="props.is_well_labo">
            <a :href="wellLaboUrl">
              <base-icon-text class="transition-bounce" :path="mdiPlayCircle" :text="t('word.well_labo')" iconClass="text-wellLabo" :open="true" />
            </a>
          </div>
        </div>
      </div>
    </layouts-auth-width>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { mdiMenu, mdiClose, mdiAccount, mdiBookOpenPageVariant, mdiCalendarCheck, mdiPlayCircle } from '@mdi/js'
import { HOME_PATH } from '@/router/routes'

import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseIconText from '@/components/BaseIconText.vue'

export default defineComponent({
  components: {
    LayoutsAuthWidth,
    BaseIconText
  },
  props: {
    is_well_labo: {
      type: Boolean
    }
  },
  setup(props) {
    const { t } = useI18n()
    const store = useStore()

    return {
      t,
      store,
      mdiMenu,
      mdiClose,
      mdiBookOpenPageVariant,
      mdiCalendarCheck,
      mdiAccount,
      mdiPlayCircle,
      homePath: HOME_PATH,
      wellLaboUrl: process.env.VUE_APP_WELL_LABO_URL,
      props
    }
  },
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
